function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.166 6.5V4.833a4.167 4.167 0 00-8.333 0V6.5A2.5 2.5 0 00.333 9v5.833a2.5 2.5 0 002.5 2.5h8.333a2.5 2.5 0 002.5-2.5V9a2.5 2.5 0 00-2.5-2.5zM4.499 4.833a2.5 2.5 0 115 0V6.5h-5V4.833zm7.5 10a.833.833 0 01-.833.834H2.833a.833.833 0 01-.834-.834V9a.833.833 0 01.834-.833h8.333a.833.833 0 01.833.833v5.833z"
});
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18
  }, props), _ref);
}
export default SvgLock;